module.exports = __webpack_public_path__ + "img/05.854f460b.gif";